module.exports = __webpack_public_path__ + "media/images/icon__predict-60cb8d48626aa1df060a978a7174e0cf.png";